import { logError } from "../../src/components/logger";

export const getAPIBase = () => {
    return 'https://ai.staging.app.familydoctor.com.au';
  };
  
  export const createHeaders = async () => {
    return {
      Accept: 'application/json',
      'x-api-key': 'RGJHAezUbT9zK7IOePsz576vmwyAmOxH2eoqDOdV',
    };
  };
  
  export const fetchAppConfig = async (appId: string) => {
    const path = `/configurations/servicebooking?appId=${appId}`;
  
    try {
      const res = await fetch(getAPIBase() + path, {
        method: 'GET',
        headers: await createHeaders(),
      });
      //Promise.all(res)
      //console.log(res.json());
      if (!res.ok) throw new Error('Failed to fetch config');
      return await res.json();
    } catch (err) {
      logError('Error fetching app config', err);
      console.error('Error fetching app config:', err);
      throw err;
    }
  };
  